export const DEFAULT_STOCK_UNIT = "un";

export const STOCK_UNIT_OPTIONS = [
  { value: "un", label: "Unidades", family: "count", factor: 1 },
  { value: "kg", label: "Kg", family: "mass", factor: 1000 },
  { value: "g", label: "Gr", family: "mass", factor: 1 },
  { value: "l", label: "Litros", family: "volume", factor: 1000 },
  { value: "ml", label: "Ml", family: "volume", factor: 1 },
  { value: "por", label: "Porciones", family: "portion", factor: 1 },
];

const STOCK_UNIT_MAP = new Map(
  STOCK_UNIT_OPTIONS.map((unit) => [unit.value, unit])
);

export const normalizeStockUnit = (value) =>
  STOCK_UNIT_MAP.has(value) ? value : DEFAULT_STOCK_UNIT;

export const getStockUnitDefinition = (value) =>
  STOCK_UNIT_MAP.get(normalizeStockUnit(value)) || STOCK_UNIT_MAP.get(DEFAULT_STOCK_UNIT);

export const areStockUnitsCompatible = (fromUnit, toUnit) => {
  const fromDefinition = getStockUnitDefinition(fromUnit);
  const toDefinition = getStockUnitDefinition(toUnit);

  return fromDefinition.family === toDefinition.family;
};

export const convertStockQuantity = (quantity, fromUnit, toUnit) => {
  const safeQuantity = Number(quantity);

  if (!Number.isFinite(safeQuantity)) {
    return null;
  }

  const normalizedFromUnit = normalizeStockUnit(fromUnit);
  const normalizedToUnit = normalizeStockUnit(toUnit);

  if (normalizedFromUnit === normalizedToUnit) {
    return safeQuantity;
  }

  if (!areStockUnitsCompatible(normalizedFromUnit, normalizedToUnit)) {
    return null;
  }

  const fromDefinition = getStockUnitDefinition(normalizedFromUnit);
  const toDefinition = getStockUnitDefinition(normalizedToUnit);
  const quantityInBaseUnit = safeQuantity * fromDefinition.factor;

  return quantityInBaseUnit / toDefinition.factor;
};
